export default __webpack_public_path__ + "static/media/white-freehand-polygon-measure-icon.e01a9cd4.svg";